export var de = {
    required: 'Erforderlich',
    deprecated: 'Veraltet',
    deprecated_and_sunset_on: 'Diese Operation ist veraltet und wird am ${1} eingestellt.',
    stability_experimental: 'Experimentell',
    stability_alpha: 'Alpha',
    stability_beta: 'Beta',
    copy_to_clipboard: 'In die Zwischenablage kopieren',
    copied: 'Kopiert',
    no_content: 'Kein Inhalt',
    unresolved_reference: 'Nicht aufgelöste Referenz',
    circular_reference: 'Zirkuläre Referenz',
    read_only: 'Nur lesen',
    write_only: 'Nur schreiben',
    optional: 'Optional',
    min: 'Min',
    max: 'Max',
    nullable: 'Nullfähig',
    body: 'Rumpf',
    payload: 'Nutzlast',
    headers: 'Kopfzeilen',
    authorizations: 'Autorisierungen',
    responses: 'Antworten',
    path_parameters: 'Pfadparameter',
    query_parameters: 'Abfrageparameter',
    header_parameters: 'Header-Parameter',
    attributes: 'Attribute',
    test_it: 'Teste es',
    information: 'Information',
    success: 'Erfolg',
    redirect: 'Umleitung',
    error: 'Fehler',
    show: 'Anzeigen',
    hide: 'Verstecken',
    available_items: 'Verfügbare Elemente',
    child_attributes: 'Unterattribute',
};
